// extracted by mini-css-extract-plugin
export default {"mainView":"MainView_mainView__ElHxW"};